import { TachDialogCtrl } from './tach.dialog'
import { UrlBindController } from './urlbind'
import angular from 'angular'
import { ListController } from './list-controller.class'
import { JsTableController } from '../components/js-table/js-table.component'

export default angular
  .module('gruz.controllers', [])
  .controller('gruz.tachDialog', TachDialogCtrl)
  .controller('gruz.urlbind', UrlBindController)
  .controller('listController', ListController)
  .controller('jsTableController', JsTableController).name
